import { FC, useEffect, useCallback, useState } from 'react';
import { LogViewer } from '@patternfly/react-log-viewer';
import { useLogState } from 'client/state/LogState';

export const LogConsole: FC<{ jobUUID: string | null }> = ({ jobUUID = null }) => {
  //console.log('LogConsole', jobUUID);
  const [load, subscribe, unsubscribe] = useLogState((state) => [state.load, state.subscribe, state.unsubscribe]);
  const [lines, setLines] = useState<string>('');

  // Auto-scroll if we are near end of log, else keep position
  const [scrollOffsetToBottom, setScrollOffsetToBottom] = useState<number>(0);

  const resetLog = useCallback((entries: string[]) => {
    setLines(entries.reduce((lines, entry) => lines + `${entry}\n`, ''));
  }, []);

  const appendLog = useCallback((entry: string) => {
    setLines((lines) => lines + `${entry}\n`);
  }, []);

  useEffect(() => {
    if (!jobUUID) {
      setLines('');
      return;
    }

    const entries = load(jobUUID);
    resetLog(entries);
    subscribe(jobUUID, appendLog);

    return () => unsubscribe(jobUUID, appendLog);
  }, [jobUUID]);

  const lineCount = lines.split('\n').length - 1;

  return (
    <div style={{ fontFamily: 'monospace', color: 'white', fontSize: '11px' }}>
      <LogViewer
        hasLineNumbers={true}
        scrollToRow={scrollOffsetToBottom < 100 ? lineCount : undefined}
        onScroll={({ scrollDirection, scrollOffset, scrollOffsetToBottom, scrollUpdateWasRequested }) => {
          //console.log('S', scrollDirection, scrollOffset, scrollOffsetToBottom, scrollUpdateWasRequested);
          setScrollOffsetToBottom(scrollOffsetToBottom);
        }}
        height={'100%'}
        data={lines}
        theme={'dark'}
        fastRowHeightEstimationLimit={50}
      />
    </div>
  );
};
